// @flow
import React from 'react';
import { I18n } from '@lingui/react';

import styled, { css, type StyledComponent } from 'styled-components';

import { MQ, Spacing } from '@rover/react-lib/styles';

import StateInput from '../../formFields/StateInput';
import TextInput from '../../formFields/TextInput';

type Props = {
  value: string,
  onChange: string => void,
  validationError: ?string,
  isUS: boolean,
};

const stateFieldCSS = css`
  flex: 1;
  margin-left: ${Spacing.M};

  ${MQ.XS} {
    width: 100%;
    flex: none;
    margin-left: 0;
  }
`;

const StyledStateInput: StyledComponent<React$ElementConfig<typeof StateInput>, {}, any> = styled(
  StateInput
)`
  ${stateFieldCSS};
`;

const StyledTextInput: StyledComponent<React$ElementConfig<typeof TextInput>, {}, any> = styled(
  TextInput
)`
  ${stateFieldCSS};
`;

const AddressFormStateField = ({ isUS, ...other }: Props) => (
  <I18n>
    {({ i18n }) =>
      isUS ? (
        <StyledStateInput
          label={i18n._('State')}
          name="state"
          data-qa-id="input-select-address-state"
          {...other}
        />
      ) : (
        <StyledTextInput
          label={i18n._('State/Province')}
          name="state"
          data-qa-id="input-select-address-state-province"
          {...other}
        />
      )
    }
  </I18n>
);

export default AddressFormStateField;



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/AddressForm/AddressFormStateField.jsx